import React, { useEffect, useState } from 'react';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { authAxios } from '../../config/config';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { correctContactValue } from '../../Helper/helper';

const AddHotOffers = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [formData, setFormData] = useState({
        name: { en: '', ar: '' },
        description: { en: '', ar: '' },
        address: { en: '', ar: '' },
        image: '',
        discount: 0,
        startDate: null,
        endDate: null,
        isActive: true,
        email: "",
        contactNumber: "",
        facebook: "",
        instagram: "",
        twitter: "",
        youtube: "",
        linkedin: ""
    });

    const handleInputChange = (field, lang, value) => {
        if (lang) {
            setFormData((prev) => ({
                ...prev,
                [field]: {
                    ...prev[field],
                    [lang]: value,
                },
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [field]: value,
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            startDate: formData.startDate ? formData.startDate.toISOString() : '',
            endDate: formData.endDate ? formData.endDate.toISOString() : '',
        };

        console.log("Payload:", payload);


        if (allmodel?.data?._id) {
            handleUpdate(payload);
        } else {
            handleAdd(payload);
        }
    };

    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        if (file.size > 10 * 1024 * 1024) {
            toast.error('File size should be less than 10MB.');
            return;
        }
        const formData = new FormData();
        formData.append('file', file);
        await authAxios()
            .post('/admin/upload/single', formData)
            .then((response) => {
                const resData = response.data;
                toast.success(resData.message);
                setFormData((prev) => ({
                    ...prev,
                    image: resData.data.url,
                }));
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
    };

    useEffect(() => {
        if (allmodel && allmodel?.data?._id) {
            setFormData({
                name: allmodel.data.name || { en: '', ar: '' },
                description: allmodel.data.description || { en: '', ar: '' },
                address: allmodel.data.address || { en: '', ar: '' },
                image: allmodel.data.image || '',
                discount: allmodel.data.discount || 0,
                startDate: allmodel.data.startDate ? new Date(allmodel.data.startDate) : null,
                endDate: allmodel.data.endDate ? new Date(allmodel.data.endDate) : null,
                isActive: allmodel.data.isActive,
                facebook: allmodel.data.facebook,
                instagram: allmodel.data.instagram,
                twitter: allmodel.data.twitter,
                youtube: allmodel.data.youtube,
                linkedin: allmodel.data.linkedin,
                email: allmodel.data.email,
                contactNumber: allmodel.data.contactNumber,
            });
        }
    }, []);

    return (
        <div className="fixed inset-0 z-10">
            <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
                    <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="px-6 py-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-6">
                                {allmodel?.data?._id ? 'Update Hot Offer' : 'Add Hot Offer'}
                            </h2>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="flex items-center gap-4">
                                    <label className="flex-1 text-sm font-medium text-gray-900">English</label>
                                    <label className="flex-1 text-sm font-medium text-gray-900">Arabic</label>
                                </div>

                                {['name', 'description'].map((field) => (
                                    <div key={field} className="flex  gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 capitalize text-justify">
                                            {field}
                                        </label>

                                        {field === 'description' ? (
                                            <div className="flex flex-col w-full">
                                                <textarea
                                                    placeholder={`${field} (EN)`}
                                                    value={formData[field]?.en || ''}
                                                    onChange={(e) => handleInputChange(field, 'en', e.target.value)}
                                                    required
                                                    className="flex-1 mb-4 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                    rows={5}
                                                />
                                                <textarea
                                                    placeholder={`${field} (AR)`}
                                                    value={formData[field]?.ar || ''}
                                                    onChange={(e) => handleInputChange(field, 'ar', e.target.value)}
                                                    required
                                                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                    rows={5} 
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                <input
                                                    type="text"
                                                    placeholder={`${field} (EN)`}
                                                    value={formData[field]?.en || ''}
                                                    onChange={(e) => handleInputChange(field, 'en', e.target.value)}
                                                    required
                                                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                />
                                                <input
                                                    type="text"
                                                    placeholder={`${field} (AR)`}
                                                    value={formData[field]?.ar || ''}
                                                    onChange={(e) => handleInputChange(field, 'ar', e.target.value)}
                                                    required
                                                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                />
                                            </>
                                        )}
                                    </div>
                                ))}



                                {['address'].map((field) => (
                                    <div key={field} className="flex items-center gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 capitalize text-justify">
                                            {field}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder={`${field} (EN)`}
                                            value={formData[field]?.en || ''}
                                            onChange={(e) => handleInputChange(field, 'en', e.target.value)}

                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                        <input
                                            type="text"
                                            placeholder={`${field} (AR)`}
                                            value={formData[field]?.ar || ''}
                                            onChange={(e) => handleInputChange(field, 'ar', e.target.value)}

                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                    </div>
                                ))}
                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Contact Number</label>
                                    <input

                                        type="text"
                                        placeholder="Contact Number"
                                        value={formData.contactNumber}
                                        onChange={(e) => setFormData({ ...formData, contactNumber: correctContactValue(e.target.value) })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>
                                <div className="grid grid-cols-12 gap-4">
                                    <div className="col-span-3">
                                        <label className="block text-sm font-medium text-gray-900 text-justify">Cover Photo</label>
                                    </div>
                                    <div className="col-span-9">
                                        {formData.image === '' ? (
                                            <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                                                <PhotoIcon className="text-gray-300 h-12 w-12 mb-2" />
                                                <div className="flex items-center text-sm text-gray-600">
                                                    <label
                                                        htmlFor="file-upload"
                                                        className="cursor-pointer rounded-md bg-white font-semibold text-indigo-600 hover:text-indigo-500"
                                                    >
                                                        Upload a file
                                                        <input

                                                            id="file-upload"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handleProfileChange}
                                                            className="sr-only"
                                                        />
                                                    </label>
                                                    <p className="pl-2">or drag and drop</p>
                                                </div>
                                                <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                                            </div>
                                        ) : (
                                            <div>
                                                <img
                                                    src={`${process.env.REACT_APP_IMAGE_URL}/${formData.image}`}
                                                    alt="Cover"
                                                    className="w-full h-40 object-cover rounded-lg mb-3"
                                                />
                                                <label
                                                    htmlFor="file-upload"
                                                    className="cursor-pointer rounded-md bg-white font-semibold text-indigo-600 hover:text-indigo-500"
                                                >
                                                    Change Image
                                                    <input
                                                        id="file-upload"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleProfileChange}
                                                        className="sr-only"
                                                    />
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Discount</label>
                                    <input

                                        type="text"
                                        placeholder="Discount"
                                        value={formData.discount}
                                        onChange={(e) => setFormData({ ...formData, discount: e.target.value })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>

                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Email</label>
                                    <input

                                        type="email"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-900">Start Date</label>
                                        <DatePicker
                                            minDate={new Date()}
                                            selected={formData.startDate}
                                            onChange={(date) => handleInputChange('startDate', null, date)}
                                            dateFormat="yyyy-MM-dd"
                                            className="w-full rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                            placeholderText="Select start date"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-900">End Date</label>
                                        <DatePicker
                                            minDate={new Date()}
                                            selected={formData.endDate}
                                            onChange={(date) => handleInputChange('endDate', null, date)}
                                            dateFormat="yyyy-MM-dd"
                                            className="w-full rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                            placeholderText="Select end date"
                                        />
                                    </div>
                                </div>



                                <div className="flex  gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Social Links</label>
                                    <div className="grid grid-cols-2 gap-4">
                                        {[
                                            { field: "facebook", label: "Facebook URL" },
                                            { field: "instagram", label: "Instagram URL" },
                                            { field: "twitter", label: "Twitter URL" },
                                            { field: "youtube", label: "Yotube URL" },
                                            { field: "linkedin", label: "LinkdedIn URL" },
                                        ].map(({ field, label }) => (
                                            <input
                                                key={field}
                                                type="text"
                                                placeholder={label}
                                                value={formData[field] || ""}
                                                onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                                                className="w-full rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                            />
                                        ))}
                                    </div>
                                </div>


                                <div className="flex items-center justify-between mt-4">
                                    <label className="text-sm font-medium text-gray-900 text-justify">Active</label>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="sr-only peer"
                                            checked={formData.isActive}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, isActive: e.target.checked }))
                                            }
                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-600 peer-focus:ring-offset-2 rounded-full peer-checked:bg-indigo-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-1 after:left-1 after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
                                    </label>
                                </div>





                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                    >
                                        {allmodel?.data?._id ? 'Update' : 'Add'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddHotOffers;
